import { UseFormReturn } from "react-hook-form";

import { useGlobalData } from "../../GlobalDataProvider";
import { IModuleRound, useRound } from "../../../modules/roundHandler";
import { IGlobalData, MapTooltip } from "../../../types/globalData";
import Funktionskontroller from "./Funktionskontroller";
import BFLNote from "./BFLNote";
import { bfv_J11 } from "../../../modules/Beräkningsmoduler/BFV_J11";
import DebugInfo from "./DebugInfo";
import SelectEditor from "../../Global/Editors/SelectEditor";
import { IModuleVärmeEl } from "../../../types/ModuleDatas";
import { nameof } from "../../Global/Utils";
import NumberEditor from "../../Global/Editors/NumberEditor";
import { IJ11_BFData } from "../../../types/BFDatas";
import { useEffect } from "react";
import { useBflHandler } from "../../../modules/Beräkningsmoduler/bflHandler";
import { BFLType } from "../../../types/DBTables";
import DriftOptimeringar from "./DriftOptimeringar";
import ErrorInfo from "./ErrorInfo";
import { Card } from "react-bootstrap";
import TemperaturInfo from "./TemperaturInfo";
import { logDebugSilently } from "../../../modules/logger";

interface IProps {
  module: IModuleRound;
  formHook: UseFormReturn;
}

const BFV_J11 = ({ module, formHook }: IProps) => {
  const roundHandler = useRound();
  const global = useGlobalData();
  const bflHandler = useBflHandler();
  //const moduleData: IModuleVärmeEl = module.data;
  const bfData: IJ11_BFData | undefined = module.data?.data;

  const bimHandler = roundHandler.getBimHandler();
  const watch = formHook.watch;

  // Callback version of watch.  It's your responsibility to unsubscribe when done.
  useEffect(() => {
    const subscription = watch((value, { name, type }) => {
      //const bfJRes = bfv_J11().getResult(module, bimHandler, roundHandler, global.data as IGlobalData);
      if (name === "data.nyInställning" || name === "data.harAngettNyInställning") {
        //Update from From
        const formData: any = formHook.getValues();
        const bflResult = bflHandler.prepareData(module, BFLType.BFV_J11, formData);

        module.bfs.BFV_J11 = bflResult;
        formHook.reset(bflResult);
        logDebugSilently("BFV_J11.watch");
      }
    });
    return () => subscription.unsubscribe();
  }, [watch, global.data, formHook, roundHandler, module]);

  const formData: any = formHook.getValues();
  const bm = bfv_J11().getResult(module, bimHandler, roundHandler, global.data as IGlobalData, formData);

  const funktionsKontroller = bm.funktionsKontroller;
  const driftOptimeringar = bm.driftOptimeringar;
  const harAngettNyInställning = formHook.watch("data.harAngettNyInställning");
  const systemText = global.beräkningsflikarText.beskr_BFV_J11;

  const inställningsvärdeGenomsnittVal = module.data[nameof<IModuleVärmeEl>("termostatInställningsvärde")];
  const inställningsvärdeGenomsnitt = new Intl.NumberFormat("sv-SE", { maximumFractionDigits: 1 }).format(inställningsvärdeGenomsnittVal);

  return (
    <div>
      <Card className="mb-3">
        <Card.Header>{systemText?.title}</Card.Header>
        <Card.Body>
          {/* Funktionskontroll för Vattenburet sekundärvärmesystem. Regleravvikelse framledning. */}
          <div dangerouslySetInnerHTML={{ __html: systemText?.body as string }} />
          {bm.data?.temperaturInfo && <TemperaturInfo tempInfo={bm.data.temperaturInfo.tempInfo} stickprov={bm.data.temperaturInfo.stickprov} />}
          <Funktionskontroller bfName="BFV_J11" formHook={formHook} funktionsKontroller={funktionsKontroller} />
          <Card className="mb-3">
            <Card.Header>Manuella kontroller</Card.Header>
            <Card.Body>
              <div className="row ml-0">
                <div className="col-lg-6">
                  <SelectEditor
                    label="Har angivit ny termostatinställning"
                    formHook={formHook}
                    fieldName={"data." + nameof<IJ11_BFData>("harAngettNyInställning")}
                    tooltipId={nameof<MapTooltip>("BFVJ11_harAngettNyInställning")}
                    items={["", "Ja", "Nej"]}
                    options={{ required: "Måste göra ett val" }}
                  ></SelectEditor>
                </div>
                <div className="col-lg-6">
                  {harAngettNyInställning === "Ja" ? (
                    <NumberEditor
                      label={"Ny termostatinställning (Befintligt värde: " + inställningsvärdeGenomsnitt + ")"}
                      formHook={formHook}
                      fieldName={"data." + nameof<IJ11_BFData>("nyInställning")}
                      tooltipId={nameof<MapTooltip>("BFVJ11_nyInställning")}
                      step={0.1}
                      options={{
                        validate: {
                          required: (value: any) => (value || value === 0 ? undefined : "Måste anges"),
                          min: (value: any) => (value && value < 10 ? "> 10 ℃" : undefined),
                          max: (value: any) => (value && value > 25 ? "< 25 ℃" : undefined),
                        },
                      }}
                    />
                  ) : (
                    <></>
                  )}
                </div>
              </div>
            </Card.Body>
          </Card>

          <DriftOptimeringar bfName="BFV_J11" formHook={formHook} driftOptimeringar={driftOptimeringar} />
          <BFLNote formHook={formHook} />
          <ErrorInfo info={bm.error} />
          <DebugInfo info={bm.debug} />
        </Card.Body>
      </Card>
    </div>
  );
};

export default BFV_J11;
